import { Box, PDFViewer, Text } from 'shell/components';

const FILE_URL =
    'https://timelygrader-us-upload-app-sandbox.s3.amazonaws.com/075263ad-6abb-40e9-b322-34490b0d8db9/Submission%201.pdf';

const highlights = [{ id: '1', value: 'The Ethics of Artificial Intelligence: Navigating Moral Boundaries' }];

const PDFViewerDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>PDFViewer</Text>
            <Box sx={{ width: '612px', height: '792px' }}>
                <PDFViewer highlights={highlights} url={FILE_URL} />
            </Box>
        </>
    );
};

export default PDFViewerDemo;
